import { Avatar, Badge, Dropdown } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import './headerMembers.css';
import { renderMouse } from '../../Socket';
import MembersDropdown from './MembersDropdown';

/**
 * Member avatars in the header, as milegrid's: a stack of 28px circles with a
 * 2px white ring, overlapping by 8px, a green "+N" chip past four. Milepad's
 * members list opens from it on click.
 */
const HeaderMembers = () => {
    const document = useSelector((state) => state.editor.documentInformation);
    const user = useSelector((state) => state.editor.userInformation);
    const [onlineUsers, setOnlineUsers] = useState([]);
    const [dropdownVisible, setDropdownVisible] = useState(false);
    const [memberColors, setMemberColors] = useState({});

    const collaborators = useMemo(
        () => (document?.members || []).filter((m) => m.id !== user?.userId),
        [document, user]
    );

    useEffect(() => {
        renderMouse(setOnlineUsers);
    }, []);

    const getInitials = (name = '') => {
        const names = name.split(' ');
        let initials = names[0].substring(0, 1).toUpperCase();
        if (names.length > 1) {
            initials += names[names.length - 1].substring(0, 1).toUpperCase();
        }
        return initials;
    };

    const colorFor = (memberId) => {
        if (memberColors[memberId]) return memberColors[memberId];
        let newColor;
        do {
            newColor = '#' + (Math.random() * 0xFFFFFF << 0).toString(16).padStart(6, '0');
        } while (newColor === '#CF9FFF' || Object.values(memberColors).includes(newColor));
        setMemberColors((prev) => ({ ...prev, [memberId]: newColor }));
        return newColor;
    };

    if (collaborators.length === 0) return null;

    return (
        <Dropdown
            overlay={<MembersDropdown />}
            trigger={['click']}
            visible={dropdownVisible}
            onVisibleChange={setDropdownVisible}
            placement="bottomRight"
        >
            <div className="document-members" title="Members" role="button" tabIndex={0}>
                <Avatar.Group
                    maxCount={4}
                    maxStyle={{ color: '#ffffff', backgroundColor: '#3aa76d' }}
                >
                    {collaborators.map((member) => (
                        <Badge
                            key={member.id}
                            offset={['-6%', '98%']}
                            style={{ width: '10px', height: '10px', backgroundColor: 'green' }}
                            dot={onlineUsers.some((onlineUser) => onlineUser.userName === member.name)}
                        >
                            <Avatar src={member.image} style={{ backgroundColor: colorFor(member.id) }}>
                                {getInitials(member.name)}
                            </Avatar>
                        </Badge>
                    ))}
                </Avatar.Group>
            </div>
        </Dropdown>
    );
};

export default HeaderMembers;
